import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WorkTimeEntryBreak } from 'record-it-time-common/entity/entities/WorkTimeEntry/WorkTimeEntryDto';
import { assertNotNullOrUndefined } from 'record-it-utils/utils/assert/assertNotNullOrUndefined';
import { OptionalProperties } from 'record-it-utils/utils/utilityTypes/OptionalProperties';

type CreateWorkTimeEntryState = {
  workTimeEntryToCreate: WorkTimeEntryToCreate | null;
};

export type WorkTimeEntryToCreate = {
  startDate: string;
  endDate: string;
  breaks: Array<WorkTimeEntryBreak>;
  note: string;
  userGroupId: string;
  stopwatchId: number | null;
  constructionSiteId: string | null;
  timeTrackingActivityId: string | null;
};

const initialState: CreateWorkTimeEntryState = {
  workTimeEntryToCreate: null
};

export const createWorkTimeEntrySlice = createSlice({
  name: 'createWorkTimeEntry',
  initialState,
  reducers: {
    startCreation: (state, action: PayloadAction<StartCreationPayload>) => {
      state.workTimeEntryToCreate = {
        timeTrackingActivityId: null,
        constructionSiteId: null,
        ...action.payload
      };
    },
    reset: (state) => {
      state.workTimeEntryToCreate = null;
    },
    setStartDate: (state, action: PayloadAction<string>) => {
      assertNotNullOrUndefined(
        state.workTimeEntryToCreate,
        'the createWorkTimeEntry has not been started'
      );
      state.workTimeEntryToCreate.startDate = action.payload;
    },
    setEndDate: (state, action: PayloadAction<string>) => {
      assertNotNullOrUndefined(
        state.workTimeEntryToCreate,
        'the createWorkTimeEntry has not been started'
      );
      state.workTimeEntryToCreate.endDate = action.payload;
    },
    setBreaks: (state, action: PayloadAction<Array<WorkTimeEntryBreak>>) => {
      assertNotNullOrUndefined(
        state.workTimeEntryToCreate,
        'the createWorkTimeEntry has not been started'
      );
      state.workTimeEntryToCreate.breaks = action.payload;
    },
    setConstructionSiteId: (state, action: PayloadAction<string | null>) => {
      assertNotNullOrUndefined(
        state.workTimeEntryToCreate,
        'the createWorkTimeEntry has not been started'
      );
      state.workTimeEntryToCreate.constructionSiteId = action.payload;
    },
    setTimeTrackingActivityId: (
      state,
      action: PayloadAction<string | null>
    ) => {
      assertNotNullOrUndefined(
        state.workTimeEntryToCreate,
        'the createWorkTimeEntry has not been started'
      );
      state.workTimeEntryToCreate.timeTrackingActivityId = action.payload;
    },
    setNote: (state, action: PayloadAction<string>) => {
      assertNotNullOrUndefined(
        state.workTimeEntryToCreate,
        'the createWorkTimeEntry has not been started'
      );
      state.workTimeEntryToCreate.note = action.payload;
    }
  }
});

type StartCreationPayload = OptionalProperties<
  WorkTimeEntryToCreate,
  'timeTrackingActivityId' | 'constructionSiteId'
>;
